import React from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./PagerContainer.module.scss";
import {GOTO_PAGE} from "../../Store/Actions/ActionTypes";

const PagerContainer = () => {
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const thisPage = parseInt(newFilterState.thisPage);
    const lastPage = parseInt(newFilterState.lastPage);

    const backDisabled = thisPage === 1 || newFilterState.loading;
    const frontDisabled = thisPage === lastPage || newFilterState.loading;

    const info = "Side " + thisPage + " av " + lastPage;

    const scrollTarget = document.getElementById("filtersWrapper");

    const scroll = (target) => {
        if (target) {
            target.scrollIntoView();
        }
    }

    const handleClick = (to) => {
        switch (to) {
            case 'first':
                dispatch({type: GOTO_PAGE, payload: {page: 1}});
                break;
            case 'previous':
                if (thisPage > 1) {
                    dispatch({type: GOTO_PAGE, payload: {page: (thisPage - 1)}});
                }
                break;
            case 'next':
                if (thisPage < lastPage) {
                    dispatch({type: GOTO_PAGE, payload: {page: (thisPage + 1)}});
                }
                break;
            case 'last':
                dispatch({type: GOTO_PAGE, payload: {page: lastPage}});
                break;
            default:
                break; // Just to suppress the warning...
        }
        scroll(scrollTarget);
    };

    const frontClass = frontDisabled ? styles.buttondisabled : styles.button;
    const backClass = backDisabled ? styles.buttondisabled : styles.button;

    return (
        <div className={styles.wrapper}>
            <button className={backClass} onClick={() => handleClick('first')} key="first" disabled={backDisabled} title="Første resultatside">
                <span aria-hidden="true">
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.55002 2.9L1.45002 8L6.55002 13.1" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.55002 2.9L1.45002 8L6.55002 13.1" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </button>

            <button className={backClass} onClick={() => handleClick('previous')} key="previous" disabled={backDisabled} title="Forrige resultatside">
                <span aria-hidden="true">
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.55002 2.9L1.45002 8L6.55002 13.1" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </button>

            <div className={styles.info}>{info}</div>

            <button className={frontClass} onClick={() => handleClick('next')} key="next" disabled={frontDisabled} title="Neste resultatside">
                <span aria-hidden="true">
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.45001 13.1L6.55001 8L1.45001 2.9" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </button>

            <button className={frontClass} onClick={() => handleClick('last')} key="last" disabled={frontDisabled} title="Siste resultatside">
                <span aria-hidden="true">
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.45001 13.1L6.55001 8L1.45001 2.9" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>

                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.45001 13.1L6.55001 8L1.45001 2.9" stroke="#333333" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </button>
        </div>
    );
};

export default PagerContainer;
